<template>
  <VaSidebar v-model="writableVisible" :width="sidebarWidth" :color="color" minimized-width="0">
    <pre style="display: none">!!!{{stocks}}</pre>
    <VaAccordion  v-model="value" multiple>
      <VaCollapse v-for="(route, index) in routes" :key="index">
        <template #header="{ value: isCollapsed }">
          <VaSidebarItem
            :to="route.isLink || !route.children ?  { name: route.name } : undefined"
            :active="routeHasActiveChild(route)"
            active-color="#2E9E4B3C"
            :text-color="textColor(route)"
            :aria-label="`${route.children ? 'Open category ' : 'Visit'} ${t(route.displayName)}`"
            role="button"
            hover-opacity="0.10"
          >
            <VaSidebarItemContent class="py-3 pr-2 pl-4">
              <CustomIcon  :name="route.meta.icon"/>

              <VaSidebarItemTitle class="flex justify-between items-center leading-5 font-semibold" >
                {{ t(route.displayName) }}

                <VaIcon v-if="route.children && route.showSubItems" :name="arrowDirection(isCollapsed)" size="20px" />
              </VaSidebarItemTitle>
            </VaSidebarItemContent>
          </VaSidebarItem>
        </template>
        <template v-if="route.showSubItems" #body>
          <div v-for="(childRoute, index2) in route.children" :key="childRoute.path">
            <VaSidebarItem
              :to="childRoute.path? {path: childRoute.path} : { name: childRoute.name }"
              :active="isActiveChildRoute(childRoute)"
              :active-color="activeColor"
              :text-color="textColor(childRoute)"
              :aria-label="`Visit ${t(route.displayName)}`"
              hover-opacity="0.10"
            >
              <VaSidebarItemContent class="py-3 pr-2 pl-11">
                <VaSidebarItemTitle class="leading-5 font-semibold">

                  {{ t(childRoute.displayName) }}
                </VaSidebarItemTitle>
              </VaSidebarItemContent>
            </VaSidebarItem>
          </div>
        </template>
      </VaCollapse>
    </VaAccordion>
  </VaSidebar>
</template>
<script lang="ts">
import { defineComponent, watch, ref, computed, onMounted } from "vue";
import { useRoute } from 'vue-router'

import { useI18n } from 'vue-i18n'
import { useColors } from 'vuestic-ui'
import { useProductStore } from "@/stores/products"

import navigationRoutes, { type INavigationRoute } from './NavigationRoutes'
import { api } from "@/api/api";
import CustomIcon from "@/components/icons/CustomIcon.vue";
import { storeToRefs } from "pinia";

export default defineComponent({
  name: 'Sidebar',
  components: { CustomIcon },
  props: {
    visible: { type: Boolean, default: true },
    mobile: { type: Boolean, default: false },
  },
  emits: ['update:visible'],

  setup: (props, { emit }) => {
    const { getColor, colorToRgba } = useColors()
    const route = useRoute()
    const isReady=ref(false)
    const { t } = useI18n()
    const productStore  = useProductStore()
    const {stocks} = storeToRefs(productStore)

    const value = ref<boolean[]>([])
    const routes = ref(navigationRoutes.routes)
    updateStocks()

    const writableVisible = computed({
      get: () => props.visible,
      set: (v: boolean) => emit('update:visible', v),
    })

    const isActiveChildRoute = (child: INavigationRoute) => route.name === child.name

    const routeHasActiveChild = (section: INavigationRoute) => {
      if (!section.children) {
        return route.path.endsWith(`${section.name}`)
      }

      return section.children.some(({ name }) => route.path.endsWith(`${name}`))
    }

    const setActiveExpand = () =>
      (value.value = navigationRoutes.routes.map((route: INavigationRoute) => routeHasActiveChild(route)))

    const sidebarWidth = computed(() => (props.mobile ? '100vw' : '280px'))
    const color = computed(() => getColor('background-secondary'))
    const activeColor = '#ECF4EE'

    const iconColor = (route: INavigationRoute) => (routeHasActiveChild(route) ? 'primary' : 'secondary')
    const textColor = (route: INavigationRoute) => (routeHasActiveChild(route) ? 'primary' : 'textPrimary')
    const arrowDirection = (state: boolean) => (state ? 'va-arrow-up' : 'va-arrow-down')

    watch(() => route.fullPath, setActiveExpand, { immediate: true })
    watch(() => stocks, () => {
      updateStocks()
    },
      {
        deep: true
    })

    function updateStocks() {
      const index = routes.value.findIndex(el => el.name === 'stocks')
      routes.value[index].children = stocks.value.map(stock => {
        return {
          label: stock.name,
          path: '/stocks/' + stock.id,
          name: 'product-list',
          id: stock.id,
          displayName: stock.name
        }
      })
    }


    return {
      writableVisible,
      sidebarWidth,
      value,
      color,
      activeColor,
      routeHasActiveChild,
      isActiveChildRoute,
      t,
      iconColor,
      textColor,
      arrowDirection,
      routes,
      stocks
    }
  },
})
</script>
